import 'client-only';

import { useMemo } from 'react';

import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import FLOW_TYPES from '@/services/funnelService/consts/flowType';

import { useProductSelectionAndCheckoutCommonData } from './useProductSelectionAndCheckoutCommonData';
import { usePurchaseContext } from './usePurchaseContext';

export const useTrialSizeItemPrices = () => {
  const { trialSizeItemPrices, oneTimeItemPrices } =
    useProductSelectionAndCheckoutCommonData();
  const { flowType } = useFlowContext();
  const { purchaseContext } = usePurchaseContext();

  return useMemo(() => {
    return (flowType === FLOW_TYPES.SignupSkin ||
      FLOW_TYPES.CurologyRetailOneTimeSkin) &&
      purchaseContext === 'onetime'
      ? { ...oneTimeItemPrices }
      : { ...trialSizeItemPrices };
  }, [flowType, oneTimeItemPrices, purchaseContext, trialSizeItemPrices]);
};
